import styled from 'styled-components/macro';
import { Col, Row } from '@yme/atoms/grid';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray500, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
export const TopicsListStyled = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid ${colorCoreGray500};
  border-left: 1px solid ${colorCoreGray500};
  border-right: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
`;
export const TopicsListItemStyled = styled.li `
  padding: 16px;

  border-bottom: 1px solid ${colorCoreGray500};

  &:first-child {
    border-radius: ${CORNER_RADIUS.s} ${CORNER_RADIUS.s} 0 0;
  }
  &:last-child {
    border-radius: 0 0 ${CORNER_RADIUS.s} ${CORNER_RADIUS.s};
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 12px 24px;
    cursor: pointer;

    ${({ isActive }) => isActive
    ? `border: 1px solid ${colorCoreBlack900Base};`
    : `border-bottom: 1px solid ${colorCoreGray500};`}
    ${({ isActive }) => isActive && `background-color: ${colorBlackTransparent50};`}
    
    &:hover {
      background-color: ${colorBlackTransparent50};
      color: ${colorCoreBlack900Base};
    }
  }
`;
export const SideBarStyled = styled(FlexWrapper) `
  ${ADAPTIVE.minWidth.desktop} {
    position: sticky;
    top: 148px; // header = 80px + margin-top = 48px
  }
`;
export const NoLuckHeader = styled(HeadingLevel3) `
  margin-bottom: 8px;
`;
export const NoLuckDescription = styled(RegularTextLevel3) `
  margin-bottom: 16px;
`;
export const RowStyled = styled(Row) `
  ${ADAPTIVE.maxWidth.mobile} {
    margin-left: 0;
    margin-right: 0;
    min-width: 100%;
    width: 100%;
  }
`;
export const ColStyled = styled(Col) `
  ${ADAPTIVE.maxWidth.mobile} {
    margin: 0;
    min-width: 100%;
    width: 100%;
  }
`;
